import React, { Fragment, ReactNode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface Props {
  children: ReactNode | ReactNode[];
  disabled?: boolean;
}

export const Portal = (props: Props) => {
  const { children, disabled = false } = props;

  const [portalNode, setPortalNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!disabled) {
      setPortalNode(document.body);
    }
  }, [disabled]);

  if (disabled) return <Fragment>{children}</Fragment>;

  return portalNode ? ReactDOM.createPortal(children, portalNode) : portalNode;
};

export default Portal;
